import Routing from "./Routing";
import React, { useEffect, useState, useRef } from "react";
import Keycloak from "keycloak-js";
import KeycloakLoader from "../Containers/Loaders/KeycloakLoader";

import { BrowserRouter, useParams } from "react-router-dom";

import OnboardingRouting from "./OnboardingRouting";

const Keycloakentrypoint = () => {
  const params = useParams();
 

  const dataFetchedRef = useRef(true);

  const [statekey, setstatekey] = useState({
    keycloak: null,
    authenticated: false,
  });
  const [states, setstates] = useState(undefined);
  useEffect(() => {
    if (statekey.authenticated == false) {
      const keycloacks = async () => {
        const keycloak = new Keycloak("/keycloak.json");
  

        const ram = await keycloak.init({
          onLoad: "login-required",
          checkLoginIframe: false,
        });

        setstatekey({ keycloak: keycloak, authenticated: ram });
 
        const shyam = await keycloak.loadUserInfo().then((userInfo) => {
          setstates({
            name: userInfo.name,
            email: userInfo.email,
            id: userInfo.sub,
          });
     
          localStorage.setItem("UserDetails", JSON.stringify(userInfo));
        });

      
      };

      keycloacks();
    }

  }, []);



  return (
    <>
      <BrowserRouter>
        {statekey.authenticated ? (
          JSON.parse(localStorage.getItem("UserDetails")).role == undefined ? (
            <OnboardingRouting state={statekey} />
          ) : (
            <Routing state={statekey} />
          )
        ) : (
          <div
            style={{
              height: "100vh",
              width: "100vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <KeycloakLoader />
          </div>
        )}
      </BrowserRouter>
    </>
  );
};

export default Keycloakentrypoint;
